var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./GuildProductionDesignInitiative.less');

var CommonTraineesGallery = require('front/components/CommonTraineesGallery/CommonTraineesGallery');

module.exports = Section.extend({

    el: '.GuildProductionDesignInitiative',

    events: {
        'click .GuildProductionDesignInitiative-info-block': 'toggleBlock'
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonTraineesGallery': {selector: '.CommonTraineesGallery', viewConstructor: CommonTraineesGallery}
    },



    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    },


    toggleBlock: function (e) {
        var $block = $(e.currentTarget);
        var rolledClass = '.GuildProductionDesignInitiative-info-blockRolled';
        var activeModifier = 'GuildProductionDesignInitiative-info-block--active';

        if ($(e.target).closest(rolledClass).length) return;

        if ($block.hasClass(activeModifier)) {
            $block.find(rolledClass).slideUp(200);
            $block.removeClass(activeModifier);
        } else {
            $block.find(rolledClass).slideDown(200);
            $block.addClass(activeModifier);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/GuildProductionDesignInitiative/GuildProductionDesignInitiative.js
// module id = 274
// module chunks = 0